import semver from "semver";
import { TILE_EVENTS_VERSION as runtimeVersion } from "@narmi/tile-events";

export const checkVersion = (tileVersion: string) => {
  if (!semver.valid(tileVersion)) {
    return false;
  }
  return (
    semver.major(tileVersion) === semver.major(runtimeVersion) &&
    semver.lte(tileVersion, runtimeVersion)
  );
};
